export const themes = {
    colors: {
        brand: {
            blue: {
                50: '#cbe3ff',
                100: '#beddff',
                200: '#97c8ff',
                300: '#6fb3ff',
                400: '#489fff',
                500: '#0a84ff', //main
                600: '#0063d2',
                700: '#0051aa',
                800: '#003e83',
                900: '#00356f',
            },
            red: {
                50: '#ffa29c',
                100: '#ff8f88',
                200: '#ff7d75',
                300: '#ff6a61',
                400: '#ff584e',
                500: '#ff453a', //main
                600: '#d70c00',
                700: '#c30b00',
                800: '#b00a00',
                900: '#9c0900',
            },
            green: {
                50: '#b0e2a9',
                100: '#a0dc98',
                200: '#90d687',
                300: '#80d076',
                400: '#70ca65',
                500: '#34c759', //main
                600: '#57b14b',
                700: '#4d9d43',
                800: '#43893a',
                900: '#3a7632',
            },
            darkPrimary: '#0071EE',
            darkGray: '#718096',
            veryDarkGray: '#2A2F3A',
            mediumGray: '#E2E8F0',
            gray: '#F1F3F6',
            blackCrowBlack: '#1C1C1C',
            blackCrowGrey: '#A3A7AC',
            blackCrowGreen: '#6AFA97',
            blackCrowCream: '#E9E8E8',
            blackCrowBrightGreen: '#0bdd4d',
        },
    },
    fonts: {
        regular: '16px',
        sm: '14px',
        xs: '12px',
        xxs: '8px',
        /** Default UI stack (see globals.css --font-sans) */
        sans: 'var(--font-sans)',
    },
    border: {
        radius: '8px',
        radiusNumber: 8,
    },
    button: {
        radius: '6px',
        radiusNumber: 6,
    },
}
